export default function Avatar({ color = '#575D96' }) {
  return (
    <svg id="fi-sr-following" xmlns="http://www.w3.org/2000/svg" width="14.524" height="19.365" viewBox="0 0 14.524 19.365">
      <circle id="Ellipse_393" data-name="Ellipse 393" cx="5" cy="5" r="5" transform="translate(2.295)" fill={color} />
      <path id="Path_7405" data-name="Path 7405" d="M7.262,14A7.271,7.271,0,0,0,0,21.262a.807.807,0,0,0,.807.807h12.91a.807.807,0,0,0,.807-.807A7.271,7.271,0,0,0,7.262,14Z" transform="translate(0 -2.704)" fill={color} />
    </svg>

  );
}
